import TopLayoutCareers from 'docs/src/modules/components/TopLayoutCareers';
import * as pageProps from 'docs/pages/careers/react-engineer-material-ui-maintainer.md?muiMarkdown';

export default function Page() {
  return <TopLayoutCareers {...pageProps} />;
}
